import { Bell } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { notificationsWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  notificationsWeb,
  {
    NotificationsListPage: () => import('./NotificationsListPage'),
    NotificationDetailPage: () => import('./NotificationDetailPage'),
    NotificationsLiveSubscription: () => import('./NotificationsLiveSubscription'),
    UserMenuNotificationsBadge: () => import('./UserMenuNotificationsBadge'),
  },
  { icons: { Bell } },
);
